import script from "./InputSections.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputSections.vue?vue&type=script&setup=true&lang=ts"

import "./InputSections.vue?vue&type=style&index=0&id=f7d12afa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7d12afa"]])

export default __exports__